module.exports = __webpack_public_path__ + "static/media/paulNnu.78b82423.png";